import en from './en-US';

const messages: any = {
  ...en,
};
export default messages;
